export const colors = {
  white: '#FFFFFF',
  blueLight: '#34a6f7',
  bluePrimary: '#2196f3',
  blueSoft: '#ddf1fcff',
  blueVeryLight: '#e6f0ff',
  black: '#1c1c1c',
  darkBlue: '#004a8d',
  gray333: '#333',
  gray444: '#444',
  gray555: '#555',
  border: '#e0e0e0',
  borderLight: '#e6e6e6',
  shadowBlue: 'rgba(0, 60, 120, 0.07)',
  danger: '#e74c3c',
  muted: '#999999',
  pink: '#ff84b1ff',
  pinkDark: '#d04a7b',

  // Modern UI Colors
  slate50: '#f8fafc',
  slate100: '#f1f5f9',
  slate200: '#e2e8f0',
  slate300: '#cbd5e1',
  slate400: '#94a3b8',
  slate500: '#64748b',
  slate600: '#475569',
  slate700: '#334155',
  slate800: '#1e293b',
  orange50: '#fff7ed',
  warning: '#f59e0b',
  yellow: '#f59e0b',

  // Job Portal specific colors
  blue50: '#eff6ff',
  blue500: '#3b82f6',
  blue600: '#2563eb',
  blue1890ff: '#1890ff',
  sky200: '#bae6fd',
  sky500: '#0ea5e9',
  sky600: '#0284c7',
  sky700: '#0369a1',
  green50: '#f0fdf4',
  green200: '#bbf7d0',
  green800: '#166534',
  gray8c: '#8c8c8c',
  red500: '#ef4444',
};
